import React from "react";

type Props = {
  /** What the tab is meant to show, e.g. "Client phone numbers". */
  title: string;
  /** Why it cannot be shown yet. Be specific - name the missing endpoint. */
  reason: string;
};

/**
 * Placeholder for a screen whose backing endpoint does not exist yet.
 *
 * Several detail tabs shipped with hardcoded sample rows, which read as working
 * features and made the gaps invisible - a clinic would see four Stockholm
 * addresses against a client who has none. Showing nothing, and saying why, is
 * the honest version until the endpoint exists.
 */
const UnavailableSection = ({ title, reason }: Props) => (
  <div className="m-4 rounded-[10px] border border-dashed border-slate-300 bg-slate-50/60 px-6 py-10 text-center">
    <p className="text-sm font-medium text-slate-700">{title}</p>
    <p className="mt-1.5 text-sm text-slate-500">{reason}</p>
  </div>
);

export default UnavailableSection;
